// Dil seçicinin bağlantısı — customer-web'deki eşleniğiyle aynı sözleşme.

import { useCallback, useSyncExternalStore } from "react";

import { isSupportedLocale, storeLocale, type LocaleCode } from "@novemai/i18n-sdk";

import { i18n, OPERATOR_APP_DEFAULT_LOCALE } from "./index.ts";
import { localeStorage } from "./locale-storage.ts";

function subscribe(onChange: () => void): () => void {
  i18n.on("languageChanged", onChange);
  return () => {
    i18n.off("languageChanged", onChange);
  };
}

function activeLocale(): LocaleCode {
  return isSupportedLocale(i18n.language) ? i18n.language : OPERATOR_APP_DEFAULT_LOCALE;
}

export interface LocalePreference {
  readonly locale: LocaleCode;
  readonly setLocale: (locale: LocaleCode) => void;
}

export function useLocalePreference(): LocalePreference {
  // Dil i18next tarafından da değişebiliyor (claim uygulanınca); yerel state
  // o değişimi kaçırıp yanlış düğmeyi basılı gösterirdi.
  const locale = useSyncExternalStore(subscribe, activeLocale, activeLocale);

  const setLocale = useCallback((next: LocaleCode) => {
    storeLocale(next, localeStorage);
    void i18n.changeLanguage(next);
  }, []);

  return { locale, setLocale };
}
